import React, { useCallback, useState, useEffect } from "react";
import { BoxControl, IconButtonControl, LogoControl, MenuControl, DrawerControl, LabelControl } from "doshx_controls_web";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faMagnifyingGlass, faShoppingCart, faChevronDown, faChevronRight, faBars } from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import { useDebouncedCallback } from "use-debounce";
import { useSelector } from "react-redux";
import { searchProducts } from "../api/calls/product/search_products";
import DefaultProductImage from "../assets/default-product-image.webp";
import { calculateBasketTotalQuantity } from "../helpers/general";
const ProductItem = (props) => {
    const { item, isHighlighted, onNavigate } = props;
    return (React.createElement("div", { className: "p-4 hover:bg-light-blue hover:cursor-pointer w-full", onClick: () => onNavigate(item._id) },
        React.createElement("div", { className: `flex flex-row gap-3 p-2 ${isHighlighted ? "bg-light-blue" : ""}` },
            React.createElement("div", null,
                React.createElement("img", { className: "h-[4rem] w-[4rem]", alt: item?._id, src: item?.image_url || DefaultProductImage })),
            React.createElement("div", { className: "flex flex-row justify-between gap-3 w-full" },
                React.createElement("div", { className: "" },
                    React.createElement("div", { className: "text-xs" }, item?.sku),
                    React.createElement("div", { className: "font-semibold" }, item?.title)),
                React.createElement("div", { className: "flex self-end" },
                    React.createElement("div", null,
                        "excl. Tax: AUD",
                        item?.price))))));
};
export const CustomTopHeaderControl = ({ onSearch, onAccountClick, onCartClick, logo, account, menu, colors = {
    header: {
        backgroundColor: "bg-secondary",
    },
    drawer: {
        backgroundColor: "bg-secondary",
        close: {
            backgroundColor: "bg-primary",
            iconColor: "text-secondary",
        },
        divideColor: "divide-gray-200",
        textColor: "text-primary",
        expanderIconColor: "text-gray-500",
    },
}, }) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [products, setProducts] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedDrawerItemIndex, setSelectedDrawerItemIndex] = React.useState(0);
    const [basketQty, setBasketQty] = useState("0");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);
    const navigate = useNavigate();
    const { basket } = useSelector((state) => state.basketState);
    useEffect(() => {
        setBasketQty(calculateBasketTotalQuantity(basket).toString());
    }, [basket]);
    const toggleSearch = useCallback(() => {
        setIsSearchOpen((prevValue) => !prevValue);
    }, []);
    const performSearch = useDebouncedCallback(async (value) => {
        if (!value || value.trim() === "")
            return;
        const { content } = await searchProducts({ search_string: value });
        setProducts(content);
    }, 700);
    const handleQueryChanged = useCallback((event) => {
        const value = event.target.value;
        setQuery(value);
        performSearch(value);
    }, []);
    const handleSearchKeyDown = useCallback((event) => {
        if (event.key !== "Enter")
            return;
        event.preventDefault();
        const value = query.trim();
        if (!value)
            return;
        performSearch.cancel();
        onSearch?.(value);
        setIsSearchOpen(false);
        setProducts([]);
        event.target.blur();
    }, [query, onSearch, performSearch]);
    return (React.createElement(BoxControl
    // className="shadow-sm w-full flex fixed justify-between items-center px-6 py-6 z-50"
    , { 
        // className="shadow-sm w-full flex fixed justify-between items-center px-6 py-6 z-50"
        className: "shadow-sm w-full flex flex-col fixed top-0 px-6 py-6 z-50 rounded-none", borderColor: "border-transparent", shadowColor: "shadow-light-gray", backgroundColor: "bg-secondary", addPadding: true },
        React.createElement("div", { className: "flex justify-between items-center" },
            React.createElement("div", { className: "p-2" },
                React.createElement(LogoControl, { ...logo })),
            React.createElement("div", { className: "hidden xl:flex w-full flex-row flex-wrap justify-center items-center gap-x-8 text-md font-medium mt-4" },
                React.createElement(MenuControl, { ...menu })),
            React.createElement("div", { className: "flex flex-row items-center gap-x-0" },
                React.createElement("div", { className: "hidden lg:flex" },
                    React.createElement("div", { className: `flex justify-end space-x-2 my-auto ${isSearchOpen ? "visible" : "invisible"}` },
                        React.createElement(Autocomplete, { getItemValue: (item) => item?._id, items: products || [], renderInput: (props) => React.createElement("input", { className: "w-full border rounded-full py-2 px-4", ...props, onKeyDown: handleSearchKeyDown }), renderItem: (item, isHighlighted) => React.createElement(ProductItem, { item: item, isHighlighted: isHighlighted, onNavigate: (id) => navigate(`/product/${id}`) }), value: query, onChange: handleQueryChanged, onSelect: (value) => console.log("Selected:", value), wrapperStyle: { width: `${isSearchOpen ? "15rem" : "0"}` }, menuStyle: {
                                borderRadius: "24px",
                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                background: "rgba(255, 255, 255, 1.0)",
                                padding: "2px 0",
                                fontSize: "90%",
                                position: "fixed",
                                overflow: "auto",
                                maxHeight: "50%",
                            } })),
                    React.createElement(IconButtonControl, { onClick: toggleSearch, icon: faMagnifyingGlass, size: "large", iconColor: "text-primary", backgroundColor: "bg-transparent", borderColor: "border-transparent" })),
                React.createElement(IconButtonControl, { onClick: onAccountClick, icon: faUser, size: "large", iconColor: "text-primary", backgroundColor: "bg-transparent", borderColor: "border-transparent" }),
                React.createElement("div", { className: "relative" },
                    React.createElement(IconButtonControl, { onClick: onCartClick, icon: faShoppingCart, size: "large", iconColor: "text-primary", backgroundColor: "bg-transparent", borderColor: "border-transparent" }),
                    React.createElement(LabelControl, { label: basketQty ?? "0", bold: true, size: "xsmall", textColor: "text-white", className: "absolute top-0 right-1 bg-primary rounded-full px-1 py-0.5 cursor-context-menu" })),
                React.createElement("div", { className: "xl:hidden flex" },
                    React.createElement(IconButtonControl, { onClick: setIsDrawerOpen.bind(null, true), icon: faBars, size: "large", iconColor: "text-primary", backgroundColor: "bg-transparent", borderColor: "border-transparent" }))),
            React.createElement(DrawerControl, { open: isDrawerOpen, addPadding: false, backgroundColor: colors?.drawer?.backgroundColor, close: {
                    onClick: () => {
                        setIsDrawerOpen(false);
                    },
                    backgroundColor: colors?.drawer?.close?.backgroundColor,
                    textColor: colors?.drawer?.close?.iconColor,
                }, toggleOpen: (o) => {
                    setIsDrawerOpen(o);
                } },
                React.createElement("div", { className: `divide-y ${colors?.drawer?.divideColor} w-72 pt-14` }, menu.menuItems?.map((menuItem, mainIndex) => {
                    return (React.createElement("div", { key: `menu-item-${mainIndex}`, className: `py-2` },
                        React.createElement("div", { className: "flex flex-row gap-4 items-center justify-between cursor-pointer", onClick: () => {
                                console.log("selectedDrawerItemIndex", selectedDrawerItemIndex);
                                setSelectedDrawerItemIndex(selectedDrawerItemIndex == mainIndex ? -1 : mainIndex);
                                if (menuItem.onClick) {
                                    setIsDrawerOpen(false);
                                    menuItem.onClick();
                                }
                            } },
                            React.createElement("div", { className: `${menu.textColor} pl-4 whitespace-no-wrap hover:underline flex flex-row gap-x-4` },
                                React.createElement(LabelControl, { label: menuItem.label, bold: true, textColor: colors?.drawer?.textColor ?? "text-black" }),
                                menuItem.icon && (React.createElement("span", { className: `${menuItem.iconColor}` },
                                    React.createElement(FontAwesomeIcon, { icon: menuItem.icon })))),
                            menuItem.subItems && (React.createElement("div", { className: `text-lg ${colors?.drawer?.expanderIconColor ?? menuItem.textColor ?? "text-black"} pr-4` },
                                React.createElement(FontAwesomeIcon, { icon: selectedDrawerItemIndex == mainIndex ? faChevronDown : faChevronRight })))),
                        React.createElement("div", { className: "flex flex-col gap-2" }, menuItem.subItems &&
                            selectedDrawerItemIndex == mainIndex &&
                            menuItem.subItems.map((subItem, subIndex) => {
                                return (React.createElement("div", { key: subIndex, className: `${menu.textColor} pl-8 cursor-pointer whitespace-no-wrap hover:underline`, onClick: () => {
                                        if (subItem.onClick) {
                                            setIsDrawerOpen(false);
                                            subItem.onClick();
                                        }
                                    } },
                                    React.createElement(LabelControl, { label: subItem.label, bold: true, textColor: colors?.drawer?.textColor ?? "text-black" })));
                            }))));
                })))),
        React.createElement("div", { className: "lg:hidden flex flex-col items-center w-full pt-8" },
            React.createElement(Autocomplete, { getItemValue: (item) => item?._id, items: products || [], renderInput: (props) => React.createElement("input", { className: "w-full border rounded-full py-2 px-4", ...props, onKeyDown: handleSearchKeyDown }), renderItem: (item, isHighlighted) => (React.createElement(ProductItem, { key: item._id, item: item, isHighlighted: isHighlighted, onNavigate: (id) => navigate(`/product/${id}`) })), value: query, onChange: handleQueryChanged, onSelect: (value) => console.log("Selected:", value), wrapperStyle: { width: "100%" }, inputProps: { placeholder: "Search here..." }, menuStyle: {
                    width: "500px",
                    borderRadius: "24px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                    background: "rgba(255, 255, 255, 1.0)",
                    padding: "2px 0",
                    fontSize: "90%",
                    position: "fixed",
                    overflow: "auto",
                    maxHeight: "50%",
                } }))));
};
